export default __webpack_public_path__ + ".well-known/apple-developer-merchantid-domain-association";